module.exports = __webpack_public_path__ + "img/icon_diagnosis_easy.557daedc.svg";